import {Component, Fragment} from 'react';
import {get} from 'lodash';

import ApiService from '-/services/ApiService';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    componentDidCatch(error, info) {
        this.setState({hasError: true});
        const cause = get(error, 'cause', '');
        const message = get(error, 'message', '');
        const stack = get(error, 'stack', '');
        ApiService.sendError({
            error: {message, stack},
            info: {
                ...info,
                url: window.location.href
            }
        });

        if (cause === 'missingCoAppStips') {
            setTimeout(() => {
                window.location.href = window.location.href.replace('coApp', 'app');
            }, 4000);
        }
    }

    render() {
        const {hasError} = this.state;
        const {children} = this.props;
        return (
            <Fragment>
                {hasError ? (
                    <div className="center">
                        <h1>An Error Has Occurred</h1>
                        <h2>Sorry for the inconvenience!</h2>
                        <p className="info">
                            The issue has been reported to our development team
                            and will be resolved very soon.
                        </p>
                    </div>
                ) : children}
            </Fragment>
        );
    }
}

export default ErrorBoundary;
